import editForm from 'formiojs/components/select/Select.form';
import *  as formioDefaults from '../formio/defaults';

export default function(...extend) {
    const selectDefaults = formioDefaults.default.specificFields.select;
    const beaconConfig = [{
        key: 'data',
        components: [
            {
                key: 'illuminationValue',
                label: 'When To Illuminate The Beacon',
                type: 'select',
                data: {
                    values: [
                        {'value': 'yes', 'label': 'When any submission selects "yes", illuminate the beacon'},
                        {'value':'no', 'label': 'when any submission selects "no", illuminate the beacon'}
                    ]
                },
                defaultValue: 'yes',
                dataSrc: 'values',
                input: true,
                weight: -5
            },
            {
                key: 'data.values',
                ignore: false,
                disabled: true,
            },
        ]
    }];

    // not relevant because only adding config items, but if overwriting existing select defaults in the future, will need to dedup the resulting config
    let mergedConfig = formioDefaults.default.configMerge({beacon: beaconConfig}, {beacon: selectDefaults});

    return editForm(mergedConfig.beacon, ...extend);
}
